import { z } from 'zod/v3';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './UserBookmarkSchema.translations.json';
import {
  errorMap,
  zName,
  zSequenceNumber,
} from '../../../../common/utils/schema';

const { addTranslations, t } = i18nNsFactory('user-bookmark-schema');
addTranslations(translations);

export const UserBookmarkFormDataSchema = z.object({
  id: z.number().optional(),
  name: z.string().optional(),
  sequenceNumber: z.number().optional(),
  url: z.string().optional(),
});

export const UserBookmarkMutationDtoSchema = z.object({
  id: z.number().optional(),
  name: z.string().optional(),
  sequenceNumber: z.number().optional(),
  url: z.string().optional(),
});

export const UserBookmarkValidFormDataSchema = z.object({
  id: z.number().optional(),
  name: zName(errorMap(() => t('validation.name.required'))).min(1),
  sequenceNumber: zSequenceNumber().optional(),
  url: z.string(),
});

export const UserBookmarksFormDataSchema = z.object({
  bookmarks: z.array(UserBookmarkFormDataSchema),
});

export const UserBookmarksValidFormDataSchema = z.object({
  bookmarks: z.array(UserBookmarkValidFormDataSchema),
});
